module.exports = __webpack_public_path__ + "img/icon_rhythm_color.b6196e98.svg";